
<span class="tit-dia"> {{ txtDia }}</span>
<div  *ngIf="recebe;else naoRecebe"> 

  <div class="d-flex justify-content-between align-items-baseline card-horario card-recebe"  *ngIf="horaDePrimeiro != null && horaAtePrimeiro != null">
    <span class="tit-recebe"> <img src="assets\imgs\icons\check_circle_green.svg" alt="icone check" class="mb-1"> Recebe</span>
    <span class="tit-horario">{{ horaDePrimeiro }} ás {{ horaAtePrimeiro}}</span>
  </div>


  <div class="d-flex justify-content-between align-items-baseline mt-1 card-horario card-recebe mt-2" *ngIf="horaDeSegundo != null && horaAteSegundo != null">
      <span class="tit-recebe"> <img src="assets\imgs\icons\check_circle_green.svg" alt="icone check" class="mb-1"> Recebe</span>
      <span class="tit-horario">{{ horaDeSegundo }} ás {{ horaAteSegundo }} </span>
  </div>
  

</div>

<ng-template #naoRecebe>
  <div class="card-horario card-nao-recebe" >
  <div class="d-flex justify-content-center align-items-baseline">      
  
    <span class="tit-nao-recebe">  <img src="assets\imgs\icons\exclamation-circle.svg" alt="icone warning" class="mb-1"> Não Recebe </span>
  </div> 

  </div>
</ng-template>
